<template>
  <div>
    <main class="main reception">
      <div class="section top">
        <div class="top__headline">
          <h2>
            확인버튼을 누르시고
            <br />완료해주세요!
          </h2>
        </div>
      </div>
      <div class="section call-guidance">
        <div class="call-guidance--rectangle">
          <div class="paragraph" v-if="status === statusReexecutable">
            <h4>
               신용 평가가 완료되었습니다.
              <br />확인버튼을 눌러주세요
            </h4>
          </div>
          <div class="paragraph" v-else>
            <h4>
               펀다 상담사가 고객님께 전화하여
              <br />상세한 내용을 안내드릴 예정입니다.
              <br />
              <strong>(평균 1 영업일)</strong>
            </h4>
          </div>
        </div>
      </div>
      <div class="section bottom">
        <button
          v-ripple
          class="button next-button"
          type="button"
          @click="$router.push({name: 'dashboard'})"
        >확인</button>
      </div>
    </main>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import StatusService from '@/service/status/StatusService'

export default {
  data() {
    return {
      statusReexecutable: StatusService.statuses.REEXECUTABLE.code,
    }
  },
  created() {
    this.$store.commit('ui/headerTitle', '정보 등록하기')
    if (window.location.host === 'now.funda.kr') { window.fbq('track', 'Purchase') }
  },
  computed: {
    ...mapGetters('status', {
      status: 'getStatus',
    }),
  },
}
</script>
